export const GIFTS = [
  // Romans 12
  {
    id:"prophecy", name:"Prophecy", category:"Romans 12", ref:"Romans 12:6",
    description:"The ability to boldly speak God's truth into situations, calling people to repentance, faith, and alignment with God's purposes.",
    ministryRoles:["Preacher","Intercessor","Church planter","Evangelist","Prophetic team member"],
    howToGrow:"Study the prophetic books of Scripture. Practice speaking truth in love. Seek accountability with mature believers. Journal what you sense God saying.",
    questions:[
      "I feel a strong compulsion to speak God's truth even when it is uncomfortable.",
      "I can often sense when a group or individual is moving away from God's purposes.",
      "People have told me that something I said seemed to come directly from God for their situation.",
      "I am burdened when I see compromise or sin in the church and feel called to address it.",
      "I find it natural to call people back to Scripture and God's standards in conversation.",
    ]
  },
  {
    id:"serving", name:"Serving", category:"Romans 12", ref:"Romans 12:7",
    description:"The ability to identify and meet practical needs in the church and community, finding deep joy in supporting others behind the scenes.",
    ministryRoles:["Deacon","Hospitality team","Mercy ministry","Administration support","Community outreach"],
    howToGrow:"Look for unmet practical needs around you. Volunteer consistently. Serve without recognition. Ask others how you can help before being asked.",
    questions:[
      "I find great satisfaction in doing practical tasks that help others, even if no one notices.",
      "I am often the first to notice when something needs to be done and I just do it.",
      "I prefer to support others in their work rather than be in the spotlight myself.",
      "Helping with practical needs like setting up, cooking, or organising gives me energy.",
      "I feel fulfilled knowing that my behind-the-scenes work makes a difference.",
    ]
  },
  {
    id:"teaching", name:"Teaching", category:"Romans 12", ref:"Romans 12:7",
    description:"The ability to understand, clearly explain, and apply biblical truth in ways that help others grow in knowledge and faith.",
    ministryRoles:["Bible study leader","Sunday school teacher","Discipleship mentor","Preacher","Writer"],
    howToGrow:"Study the Bible systematically. Practice explaining concepts simply. Seek opportunities to teach small groups. Read books on biblical interpretation and communication.",
    questions:[
      "I love studying the Bible in depth and sharing what I discover with others.",
      "People often say that my explanations of Scripture make things clearer for them.",
      "I am drawn to finding the most accurate and clear way to communicate biblical truth.",
      "I feel energised when I help someone understand a passage they previously found confusing.",
      "I naturally organise information and biblical content in a way others find easy to follow.",
    ]
  },
  {
    id:"exhortation", name:"Exhortation", category:"Romans 12", ref:"Romans 12:8",
    description:"The ability to come alongside others with words of encouragement, counsel, and challenge that strengthen their faith and help them grow.",
    ministryRoles:["Counsellor","Coach","Small group leader","Mentor","Pastoral care team"],
    howToGrow:"Listen deeply before speaking. Study the book of Acts and Paul's letters for examples of exhortation. Look for people who are discouraged and intentionally encourage them.",
    questions:[
      "People naturally come to me when they are struggling and need encouragement or direction.",
      "I find it easy to see potential in others and call it out with specific, meaningful words.",
      "I am drawn to helping people take practical next steps in their faith and life.",
      "I feel compelled to challenge people lovingly when I see them settling for less than God's best.",
      "I can sense when someone needs a word of comfort versus a word of challenge.",
    ]
  },
  {
    id:"giving", name:"Giving", category:"Romans 12", ref:"Romans 12:8",
    description:"The ability to give generously and cheerfully of financial and material resources to advance God's kingdom, often with unusual wisdom about stewardship.",
    ministryRoles:["Missions supporter","Church funder","Benevolence ministry","Business as mission","Financial mentor"],
    howToGrow:"Study biblical principles of generosity. Practice giving sacrificially. Ask God where He wants you to invest. Connect with mission organisations and ministry leaders.",
    questions:[
      "I find genuine joy in giving money or resources to God's work, especially secretly.",
      "I am able to live on less than I could afford so that I can give more away.",
      "I often sense specific opportunities where my giving could make a significant difference.",
      "People have benefited significantly from my financial generosity at just the right time.",
      "I think carefully and prayerfully about where to direct financial resources for maximum kingdom impact.",
    ]
  },
  {
    id:"leadership", name:"Leadership", category:"Romans 12", ref:"Romans 12:8",
    description:"The ability to cast vision, set direction, and motivate others to work together toward God-given goals with diligence and integrity.",
    ministryRoles:["Senior pastor","Team leader","Church planter","Ministry director","Elder"],
    howToGrow:"Read biographies of godly leaders. Seek mentorship from experienced leaders. Take responsibility for outcomes. Study servant leadership in the Gospels.",
    questions:[
      "People naturally look to me for direction and I find it natural to provide it.",
      "I can see where a group needs to go and I am able to communicate that vision compellingly.",
      "I am willing to take responsibility for outcomes and make difficult decisions when needed.",
      "I think naturally in terms of goals, strategy, and mobilising people toward a common purpose.",
      "I feel energised when I am leading a team toward a meaningful God-given mission.",
    ]
  },
  {
    id:"mercy", name:"Mercy", category:"Romans 12", ref:"Romans 12:8",
    description:"The ability to feel and express compassion for those who are suffering, and to minister to them with consistent love and practical care.",
    ministryRoles:["Hospital chaplain","Prison ministry","Counsellor","Refugee support","Care home ministry"],
    howToGrow:"Spend time with those who are hurting. Study Jesus's interactions with the suffering in the Gospels. Practice empathetic listening. Guard against emotional burnout with healthy boundaries.",
    questions:[
      "I feel deep empathy for people who are suffering and am strongly drawn to help them.",
      "I am patient and consistent in caring for people through long or difficult seasons.",
      "People who are hurting are drawn to me and feel safe sharing their pain with me.",
      "I find it easy to weep with those who weep and sit with people in their pain.",
      "I am motivated to remove barriers that cause suffering, even at personal cost.",
    ]
  },
  // 1 Corinthians 12
  {
    id:"wisdom", name:"Word of Wisdom", category:"1 Corinthians 12", ref:"1 Corinthians 12:8",
    description:"The ability to apply spiritual knowledge with insight and discernment to specific situations, giving practical and godly guidance.",
    ministryRoles:["Elder","Counsellor","Mediator","Spiritual director","Leadership advisor"],
    howToGrow:"Study Proverbs and James. Ask God for wisdom in every situation. Practise listening before speaking. Seek out complex situations and pray through them carefully.",
    questions:[
      "I am often able to identify the wisest course of action in complex or difficult situations.",
      "People come to me for counsel and frequently find my perspective helpful and practically sound.",
      "I can apply biblical principles to specific real-life situations in ways that bring clarity.",
      "I have a sense of knowing what needs to happen next even when others feel confused.",
      "I am able to see multiple sides of a situation and guide people toward godly decisions.",
    ]
  },
  {
    id:"knowledge", name:"Word of Knowledge", category:"1 Corinthians 12", ref:"1 Corinthians 12:8",
    description:"The ability to receive and communicate specific information about a person or situation through the Holy Spirit beyond natural means.",
    ministryRoles:["Intercessor","Prophetic ministry","Prayer team","Healing ministry","Pastoral care"],
    howToGrow:"Develop a consistent prayer life. Keep a journal of impressions you receive in prayer. Test words carefully with Scripture and trusted leaders. Study how this gift operated in the New Testament.",
    questions:[
      "I have sometimes known specific facts about a person or situation that I could not have known naturally.",
      "During prayer, I receive impressions or insights that later prove accurate and helpful.",
      "I have a strong sense when something significant is happening in a person's life even before they tell me.",
      "Others have been significantly impacted when I shared something I sensed God was revealing.",
      "I take seriously the impressions I receive in prayer and test them carefully before sharing.",
    ]
  },
  {
    id:"faith", name:"Faith", category:"1 Corinthians 12", ref:"1 Corinthians 12:9",
    description:"The ability to trust God with extraordinary confidence for things that seem impossible, inspiring others to believe God for great things.",
    ministryRoles:["Church planter","Missionary","Intercessor","Vision caster","Prayer leader"],
    howToGrow:"Study the faith heroes in Hebrews 11. Keep a record of answered prayers. Intentionally pray for impossible things. Encourage others with stories of God's faithfulness.",
    questions:[
      "I have a strong and settled confidence that God will do what He has promised even when circumstances say otherwise.",
      "Others have been encouraged and inspired to trust God more because of my faith.",
      "I find it natural to pray boldly for things that seem humanly impossible.",
      "I am rarely paralysed by fear or doubt — I default to trusting God.",
      "I have seen God do remarkable things in response to prayer that others were afraid to offer.",
    ]
  },
  {
    id:"healing", name:"Gifts of Healing", category:"1 Corinthians 12", ref:"1 Corinthians 12:9",
    description:"The ability to serve as an instrument of God's healing power for physical, emotional, or spiritual restoration in others.",
    ministryRoles:["Prayer ministry team","Hospital chaplain","Inner healing ministry","Healing rooms","Missions"],
    howToGrow:"Study the healing ministry of Jesus. Pray boldly for the sick. Join a prayer ministry team. Learn about inner healing and emotional wholeness. Keep a record of healings you witness.",
    questions:[
      "I feel strongly led to pray for people who are sick and have seen God heal in response.",
      "I have a sense of faith rising when I pray for people with physical or emotional needs.",
      "People have reported significant improvement or full healing after I prayed for them.",
      "I am drawn to those who are suffering and feel called to intercede specifically for healing.",
      "I believe God still heals today and feel called to be part of that ministry.",
    ]
  },
  {
    id:"miracles", name:"Working of Miracles", category:"1 Corinthians 12", ref:"1 Corinthians 12:10",
    description:"The ability to serve as an instrument through which God performs powerful acts that go beyond natural explanation to confirm His presence and power.",
    ministryRoles:["Evangelist","Missionary","Prayer leader","Healing ministry","Church planter"],
    howToGrow:"Pray for opportunities to see God's power. Study the miracles of Jesus and the apostles. Step out in faith. Go to the places where natural means are insufficient.",
    questions:[
      "I have witnessed or been part of events that had no natural explanation and clearly showed God's power.",
      "I feel a strong faith to pray in situations where only a miracle will make a difference.",
      "God has used me in situations where His power was demonstrated in ways that surprised even me.",
      "I am drawn to the frontlines of ministry where human resources are insufficient.",
      "I believe God wants to demonstrate His power today and I feel called to be part of that.",
    ]
  },
  {
    id:"discernment", name:"Discernment of Spirits", category:"1 Corinthians 12", ref:"1 Corinthians 12:10",
    description:"The ability to distinguish between truth and error, and to recognise the spiritual forces at work in people, situations, and teachings.",
    ministryRoles:["Elder","Prayer team","Pastoral care","Counsellor","Worship leader"],
    howToGrow:"Study 1 John and the warnings of Jesus about false prophets. Develop a rigorous prayer life. Test everything against Scripture. Seek accountability when you sense something is wrong.",
    questions:[
      "I can often sense when something is spiritually off in a person, teaching, or situation.",
      "I have a strong ability to tell whether a teaching or message is truly from God or not.",
      "I am rarely deceived by appearances and tend to see what is really going on beneath the surface.",
      "I feel a strong internal check when something is spiritually dangerous even if I can't explain it immediately.",
      "People have valued my perspective in helping them avoid spiritual deception or harmful influences.",
    ]
  },
  {
    id:"tongues", name:"Tongues", category:"1 Corinthians 12", ref:"1 Corinthians 12:10",
    description:"The ability to speak or pray in a language not learned by the speaker, for personal edification or as a message to the church when interpreted.",
    ministryRoles:["Intercessor","Prayer team","Worship team","Personal devotional life"],
    howToGrow:"Use the gift consistently in personal prayer. Seek the gift of interpretation. Study Paul's guidance in 1 Corinthians 14. Use the gift in appropriate contexts with order and accountability.",
    questions:[
      "I have the ability to pray or speak in a language I have not learned.",
      "Praying in tongues is a significant part of my personal prayer life.",
      "I have spoken in tongues publicly in a church context with interpretation.",
      "The gift of tongues builds my personal faith and deepens my sense of connection with God.",
      "I feel this gift is an important part of my spiritual life and ministry.",
    ]
  },
  {
    id:"interpretation", name:"Interpretation of Tongues", category:"1 Corinthians 12", ref:"1 Corinthians 12:10",
    description:"The ability to interpret a message spoken in tongues so that the whole church may be edified and understand what God is saying.",
    ministryRoles:["Prayer team","Worship leader","Church elder","Prophetic team"],
    howToGrow:"Pray for sensitivity to the Holy Spirit. Practice in trusted settings. Study 1 Corinthians 14. Work in partnership with those who speak in tongues in corporate settings.",
    questions:[
      "I have experienced the ability to understand and communicate the meaning of a message in tongues.",
      "When someone speaks in tongues I sometimes receive a clear sense of what is being communicated.",
      "I feel a responsibility to provide interpretation when a message in tongues is given publicly.",
      "The gift of interpretation has been confirmed by others who recognized the accuracy of what I shared.",
      "I take this gift seriously and use it in accountable, ordered church settings.",
    ]
  },
  {
    id:"helps", name:"Helps", category:"1 Corinthians 12", ref:"1 Corinthians 12:28",
    description:"The ability to support and assist others in ministry, freeing them to focus on their calling by faithfully handling supporting tasks.",
    ministryRoles:["Ministry assistant","Administrative support","Deacon","Technical team","Children's ministry helper"],
    howToGrow:"Look for leaders who need practical support. Volunteer consistently. Find joy in enabling others to succeed. Study how Timothy and others supported Paul's ministry.",
    questions:[
      "I find great joy in supporting a leader or ministry by handling the practical details they don't have time for.",
      "I am reliable and consistent in fulfilling commitments and showing up when needed.",
      "I feel most fulfilled when my contribution enables someone else to do their ministry more effectively.",
      "I am happy to work in the background and do not need recognition or a prominent role.",
      "I have a knack for seeing what needs to be done to support a ministry or leader and doing it.",
    ]
  },
  {
    id:"administration", name:"Administration", category:"1 Corinthians 12", ref:"1 Corinthians 12:28",
    description:"The ability to organise people, resources, and plans effectively to accomplish the goals and vision of the church or ministry.",
    ministryRoles:["Church administrator","Events coordinator","Ministry manager","Team organiser","Project leader"],
    howToGrow:"Study principles of biblical stewardship and organisation. Take on coordination roles in your church. Develop systems that help others serve more effectively. Read about organisational leadership.",
    questions:[
      "I naturally create systems and structures that help groups function more effectively.",
      "I am good at organising people, resources, and logistics to accomplish a goal.",
      "Others rely on me to bring order and clarity to complex or chaotic ministry situations.",
      "I think naturally in terms of plans, timelines, and who needs to do what by when.",
      "I find administrative tasks energising when they serve a meaningful ministry purpose.",
    ]
  },
  // Ephesians 4
  {
    id:"apostle", name:"Apostle", category:"Ephesians 4", ref:"Ephesians 4:11",
    description:"The ability to pioneer new works of God, plant churches, and establish healthy foundations for ministry in new or difficult contexts.",
    ministryRoles:["Church planter","Cross-cultural missionary","Mission team leader","Network founder","Kingdom entrepreneur"],
    howToGrow:"Study the ministry of Paul in Acts. Seek mentorship from experienced church planters. Develop a deep prayer life. Be willing to go where the gospel has not yet taken root.",
    questions:[
      "I feel a strong calling to start new ministries or churches rather than maintain existing ones.",
      "I am able to function effectively in new environments where there is no established structure.",
      "I have a pioneering spirit and thrive in situations that require building something from scratch.",
      "God has used me to establish new expressions of church or ministry in different contexts.",
      "I feel drawn to unreached people or places where the gospel has little or no presence.",
    ]
  },
  {
    id:"evangelist", name:"Evangelist", category:"Ephesians 4", ref:"Ephesians 4:11",
    description:"The ability to clearly and compellingly communicate the gospel to unbelievers in a way that leads to faith and response.",
    ministryRoles:["Street evangelist","Outreach leader","Missions team","Alpha course leader","Campus minister"],
    howToGrow:"Practise sharing your testimony. Study the evangelistic methods of Jesus and Paul. Look for opportunities to have spiritual conversations. Pray regularly for specific people to come to faith.",
    questions:[
      "I find it natural and energising to share my faith with people who don't know Jesus.",
      "People have come to faith or moved significantly toward God through my conversations with them.",
      "I feel a strong burden for people who don't know Christ and regularly pray for their salvation.",
      "I can communicate the gospel clearly and simply in a way that makes sense to non-Christians.",
      "I look for opportunities to steer conversations toward spiritual topics and the good news of Jesus.",
    ]
  },
  {
    id:"pastor", name:"Pastor / Shepherd", category:"Ephesians 4", ref:"Ephesians 4:11",
    description:"The ability to nurture, protect, and care for a community of believers over the long term, guiding them toward spiritual maturity.",
    ministryRoles:["Senior pastor","Small group leader","Chaplain","Youth pastor","Care group facilitator"],
    howToGrow:"Study the Good Shepherd passages in John 10. Invest deeply in a consistent group of people. Learn to protect the flock from harmful influences. Practise long-term commitment to relationships.",
    questions:[
      "I feel a deep responsibility for the spiritual wellbeing of a specific group of people I am connected to.",
      "I am committed to the long-term growth of people rather than short-term results.",
      "I naturally notice when someone in my community is struggling and reach out to them.",
      "People feel genuinely cared for, known, and safe in my presence.",
      "I am willing to make personal sacrifices to ensure the people I shepherd are healthy and growing.",
    ]
  },
  {
    id:"teacher_eph", name:"Teacher", category:"Ephesians 4", ref:"Ephesians 4:11",
    description:"The ability to communicate biblical truth with depth and clarity in a way that equips the body of Christ to live and minister effectively.",
    ministryRoles:["Preacher","Bible college lecturer","Discipleship trainer","Author","Seminary professor"],
    howToGrow:"Develop deep and consistent Bible study habits. Teach at every opportunity. Seek feedback on your communication. Write down what you learn. Invest in formal theological study.",
    questions:[
      "I am strongly drawn to studying Scripture in depth and communicating what I find to others.",
      "My teaching has been used to bring significant clarity and growth to those I have taught.",
      "I am able to take complex theological truths and make them accessible and applicable.",
      "I feel a responsibility to ensure that what I teach is accurate, well-grounded, and life-changing.",
      "Others have grown significantly in their understanding of Scripture and their faith through my teaching.",
    ]
  },
];

export const GIFT_CATEGORIES = ["Romans 12","1 Corinthians 12","Ephesians 4"];
